import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SplashScreen from "../Splash";

// PrivateRoute component as a wrapper for protected routes
const PrivateRoute = ({ sessionLoader, loginLoader, gameLoader, children }) => {
  const { user, loading } = useSelector(({ Auth }) => Auth);

  if (user?._id) {
    if (!user.status === "pending") {
      return <Navigate to="/verify-otp" />;
    }
    return children;
  } else if (sessionLoader || loginLoader || gameLoader || loading) {
    return <SplashScreen />;
  }
  return <Navigate to="/login" />;
};

export default PrivateRoute;
